import { FormViewField } from 'components/FormView';
export default {
  formName: 'SupplierEnquiryFilterRow',
  validate: null,
  rowModelType: 'serverSide',
  parameters: [
    {
      id: 1,
      type: 'TEXT_FIELD',
      visible: true,
      props: {
        label: 'Supplier Name',
        name: 'SupplierName',
        size: 'medium',
      }
    },
    {
      id: 2,
      type: 'TEXT_FIELD',
      visible: true,
      props: {
        label: 'Phone',
        name: 'Phone',
        disabled: true,
        size: 'medium',
      }
    },
    {
      id: 3,
      type: 'TEXT_FIELD',
      visible: true,
      props: {
        label: 'City',
        name: 'City',
        disabled: true,
        size: 'medium',
      }
    },
    {
      id: 4,
      type: 'TEXT_FIELD',
      visible: true,
      props: {
        label: 'State',
        name: 'State',
        disabled: true,
        size: 'medium',
      }
    },
    {
      id: 5,
      type: 'EX_LOOKUP_FIELD',
      props: {
        label: 'Supplier from',
        name: 'SupplierFrom',
        suppressValidation: true,
        disableOptionsLookup: true,
        isDisplayValue: true,
        size: 'small',
        lookupName: 'Supplier',
        style: {
          display: 'inline-block',
          marginRight: '16px',
        }
      }
    },
    {
      id: 6,
      type: 'EX_LOOKUP_FIELD',
      props: {
        label: 'Supplier to',
        name: 'SupplierTo',
        suppressValidation: true,
        disableOptionsLookup: true,
        isDisplayValue: true,
        size: 'small',
        lookupName: 'Supplier',
        style: {
          display: 'inline-block',
        }
      }
    },
    {
      id: 7,
      type: 'TOGGLE_FIELD',
      props: {
        label: 'Active Only',
        name: 'Active',
        required: false,
      }
    }
  ] as FormViewField[]
};
